import { render, staticRenderFns } from "./StudentSeisekiList.vue?vue&type=template&id=5aae319a&"
import script from "./StudentSeisekiList.vue?vue&type=script&lang=ts&"
export * from "./StudentSeisekiList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports